module.exports = __webpack_public_path__ + "img/devices.fcbd807b.svg";